export const getLodzConfig = () => {
  return {
    cityOptions: {
      isInLocationsPage: true,
      isCityInProgress: true,
      title: "ŁÓDŹ",
      label: "2025",
      siteUrl: "/lodz",
      siteTitle: "Pixel XL Łódź",
      nameKey: "lodz",
      isPerformanceReviewEnabled: false,
    },
  };
};
